/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import SimplePhotoUploader from '../../common/SimplePhotoUploader'
import DatePicker from '../../common/DatePicker'
import CurrencyInput from '../../common/CurrencyInput'

class AdminEducationForm extends Component {
  render() {
    const {
      formState,
      closeModal,
      loader,
      next,
      handleInputChange,
      grabPhotoData,
      isEditModal,
      handleDateChange,
      t,
    } = this.props
    return (
      <div className='row'>
        <div className='col-md-6'>
          <label htmlFor='featured-image'>{t('education.form.featuredImage')}</label>
          <SimplePhotoUploader
            sendPhotoData={grabPhotoData}
            selectedPhoto={formState.uploadPhotoSrc}
          />
        </div>
        <div className='col-md-6'>
          <div className='form-group'>
            <label htmlFor='name'>{t('education.form.educationName')}</label>
            <input
              type='text'
              name='name'
              className='form-control'
              id='name'
              placeholder={t('education.form.educationName')}
              onChange={handleInputChange}
              value={formState.name}
            />
          </div>
          <div className='form-group'>
            <label htmlFor='video_url'>{t('education.form.previewVideoUrl')}</label>
            <input
              type='text'
              name='video_url'
              className='form-control'
              id='video_url'
              placeholder={t('education.form.previewVideoUrl')}
              onChange={handleInputChange}
              value={formState.video_url}
            />
          </div>
        </div>
        <div className='col-md-6'>
          <div className='form-group'>
            <label htmlFor='price'>{t('education.form.price')}</label>
            <CurrencyInput
              className='form-control'
              max={999999}
              onValueChange={(num) => this._formatCurrencyEvent(num)}
              value={formState.price}
              style={{ textAlign: 'right' }}
            />
          </div>
        </div>
        <div className='col-md-6'>
          <div className='form-group'>
            <label>{t('education.form.startDateOptional')}</label>
            <DatePicker
              selected={formState.start_date}
              onChange={(d) => handleDateChange('start_date', d)}
            />
          </div>
        </div>
        <div className='col-md-6'>
          <div className='form-group'>
            <label>{t('education.form.endDateOptional')}</label>
            <DatePicker
              selected={formState.end_date}
              onChange={(d) => handleDateChange('end_date', d)}
            />
          </div>
        </div>
        <div className='col-md-12'>
          <div className='form-group'>
            <label htmlFor='description'>{t('common.field.description')}</label>
            <textarea
              type='text'
              name='description'
              className='form-control'
              id='description'
              placeholder={t('common.field.description')}
              onChange={handleInputChange}
              value={formState.description}
            />
          </div>
        </div>

        <div className='col-md-12 d-flex justify-content-center align-items-center mt-4'>
          <button
            className='btn btn-dark m-2'
            onClick={closeModal}
            disabled={loader}
          >
            {t('common.cancel')}
          </button>
          <button
            className='btn btn-primary m-2'
            onClick={next}
            disabled={loader}
          >
            {t(isEditModal ? 'education.form.editSections' : 'education.form.addSections')}
          </button>
        </div>
      </div>
    )
  }

  _formatCurrencyEvent = (num) => {
    const event = {
      target: {
        name: 'price',
        value: num,
      },
    }
    this.props.handleInputChange(event)
  }
}
export default withTranslation()(AdminEducationForm)
